import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserModel } from '../models/user.model';
import { LocalStoreService } from '../services/local-store.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private store : LocalStoreService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
		// this.store.setItem('token', 'DgtFiW2c+g7ynAaBxiUHswSefir8/bNyrHiMxlfW7l4olJrBhsvt/npw4NhXX4p/qQ8FeXTh+BJvsYkiNnddWJ4u6AklRuAnz5LoGfGplVV+ouCDoetq66txYq719zaBYvtGEVHujUyfGFe2sODj3DtVI6n6BdFTQ6Qing7NbTrBheVJgsDN5rU21Z3S/CUErA4xriAr1T+/skxtY6hn5fevbUCydp3uX1AE5eJSC+0t8/7+2yzHQZXRiPUwjfWf1UqK3+O0VFWsv2R0bdUp1vVAk/f/V6w1iFATyUmpRU7VpCWfibn6a91+1DvUE8z0fLoWfO1pzcSPgycue9X2PofI085EyXqSzZ6JBA7Vss45ZJCN3Je3Nes0MzHGa4cxYHuWYAH9UvTuwYH97Ezn0Q==');
        let token = this.store.getItem('token');
        // let token = user ? user['token'] : null;

        if(token){
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
        }

        return next.handle(request);
    }
}
